import { createSlice } from '@reduxjs/toolkit';

import { IState, STATE } from '../types/state';

import updateRoadsideServices from './updateRoadsideServices';
import initDirectories from './initDirectories';
import statusLoading from './statusLoading';

const initialState: IState = {
  countries: [],
  initRoadsideService: [],
  roadsideService: [],
  stationCategories: [],
  serviceFormats: [],
  additionalParams: [],
  additionalServices: [],
  services: [],
  paymentTypes: [],
};

const slice = createSlice({
  name: STATE,
  initialState,
  reducers: {
    updateRoadsideServices,
    initDirectories,
    statusLoading,
  },
});

export default slice;
